var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1095_5827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 2C9.86369 2 10.3724 2.21071 10.7475 2.58579C11.1225 2.96086 11.3333 3.46957 11.3333 4H13.3333C13.6869 4 14.026 4.14048 14.2761 4.39052C14.5261 4.64057 14.6666 4.97971 14.6666 5.33333V12.6667C14.6666 13.0203 14.5261 13.3594 14.2761 13.6095C14.026 13.8595 13.6869 14 13.3333 14H2.66659C2.31296 14 1.97382 13.8595 1.72378 13.6095C1.47373 13.3594 1.33325 13.0203 1.33325 12.6667V5.33333C1.33325 4.97971 1.47373 4.64057 1.72378 4.39052C1.97382 4.14048 2.31296 4 2.66659 4H4.66659C4.66659 3.46957 4.8773 2.96086 5.25237 2.58579C5.62744 2.21071 6.13615 2 6.66659 2H9.33325ZM12.6666 6.66667H3.33325C3.16333 6.66686 2.9999 6.73192 2.87634 6.84857C2.75278 6.96521 2.67843 7.12464 2.66847 7.29426C2.65851 7.46389 2.7137 7.63092 2.82276 7.76122C2.93182 7.89152 3.08652 7.97526 3.25525 7.99533L3.33325 8H7.33325V8.66667C7.33344 8.83659 7.3985 9.00002 7.51515 9.12358C7.6318 9.24714 7.79122 9.32149 7.96085 9.33145C8.13048 9.34141 8.2975 9.28622 8.42781 9.17716C8.55811 9.0681 8.64185 8.9134 8.66192 8.74467L8.66659 8.66667V8H12.6666C12.8365 7.99981 12.9999 7.93475 13.1235 7.8181C13.2471 7.70146 13.3214 7.54203 13.3314 7.3724C13.3413 7.20278 13.2861 7.03575 13.1771 6.90545C13.068 6.77514 12.9133 6.6914 12.7446 6.67133L12.6666 6.66667ZM9.33325 3.33333H6.66659C6.5033 3.33335 6.34569 3.3933 6.22367 3.50181C6.10165 3.61032 6.02369 3.75983 6.00459 3.922L5.99992 4H9.99992C9.9999 3.83671 9.93995 3.67911 9.83144 3.55709C9.72294 3.43506 9.57342 3.3571 9.41125 3.338L9.33325 3.33333Z",
    fill: "#314450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1095_5827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWork);
export default __webpack_public_path__ + "static/media/Ic_Work.f44c836593a63e2bbecbaab3fe2f2097.svg";
export { ForwardRef as ReactComponent };